import styled from "styled-components";

export const FranchiseHeader = styled.div<{ isApp: number | null }>`
  top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  position: fixed;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: start;
  justify-content: flex-start;
  padding: 0px 20px;
  z-index: 11;
  background: white;
  gap: 8px;

  > .close {
    cursor: pointer;
    width: 24px;
    height: 24px;
  }

  > .input-wrapper {
    position: relative;
    width: 100%;
    height: 35px;

    > input {
      width: 100%;
      height: 100%;
      border-radius: 15px;
      padding-top: 10px;
      padding-right: 12px;
      padding-bottom: 10px;
      padding-left: 12px;
      background: #f0f0f0;
      outline: none;
      border: none;
      box-sizing: border-box;

      font-weight: 600;
      font-size: 12px;
    }

    > img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 12px;
    }
  }
`;
